import gql from "graphql-tag";

export function userPermissionQuery(permission) {
    const variables = {permission};
    return {
        query: gql`
            query($permission: String!) {
                result: userPermission(permission: $permission) {
                    user {
                                 id
                                 email
                             }
                    permission{
                                  id
                                  permission
                          }
                }
            }
        `,
        variables,
    };
}
